import {FC} from 'react'
import Overview from './Overview'
import Affiliate from './Affiliate'
import Commission from './Commission'
import CommissionAmount from './CommissionAmount'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../Overview/OverviewSlice/UserDetailsSlice'

type ReferralProps = {}

const Referral: FC<ReferralProps> = () => {
  // redux data
  const userData: any = useSelector(getAllUserDetails)

  return (
    <>
      <Overview userData={userData} />
      {userData?.myReferralCodes &&
        Array.isArray(userData?.myReferralCodes) &&
        userData?.myReferralCodes.length > 0 && (
          <>
            <CommissionAmount />
            <Commission />
            <Affiliate userData={userData} />
          </>
        )}
    </>
  )
}

export default Referral
